<template>
  <transition name="modal-fade">
    <div class="modal-mask" v-if="modal">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div @click="close" class="modal-close-icon">
            <img class="button-icon" src="@/assets/icon-close-button-original.png" alt="">
          </div>

          <div class="modal-content-wrapper">

            <div class="modal-header">
              <h3>{{ header }}</h3>
            </div>

            <div class="modal-body">
              <slot>
              </slot>
            </div>

            <div class="modal-controls">
              <button @click="close" class="modal-button">いいえ</button>
              <button @click="submit" class="modal-button">はい</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: ['modal', 'header'],
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      this.$emit('submit');
    },
  },
};

</script>

<style scoped lang="scss">
@import "@/assets/style/modal_scss.scss";

</style>
